import { fabric } from 'fabric';
import { getDarkOrLightColor } from '../helpers';
import extendCanvasGroupProps from './extendCanvasGroupProps';
import getUnitLabel from './getUnitLabel';

const TEXT_OFFSET = 0.05;

const addCanvasCircle = (data, color, dropOnX, dropOnY, borderColour) => {
    data.unit = Number(data.unit);

    const borderWidth = borderColour ? 3 : 0;
    const radius = 10;
    const adjustedRadius = radius + borderWidth / 2;

    const circle = new fabric.Circle({
        originX: 'center',
        originY: 'center',
        radius: adjustedRadius,
        fill: color,
        stroke: borderColour || 'transparent',
        strokeWidth: borderWidth,
        padding: 10,
        hasRotatingPoint: false,
        type: 'circle',
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    const textObject = new fabric.Text(getUnitLabel(data.unit), {
        fontFamily: 'Roboto, Arial, Sans-serif',
        fontWeight: 'normal',
        scaleY: 1 + TEXT_OFFSET,
        fontSize: 12 - TEXT_OFFSET,
        fill: getDarkOrLightColor(color || '', '#ffffff', '#000000'),
        type: 'text',
        attributeId: data.type,
        originX: 'center',
        originY: 'center',
        textAlign: 'center',
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    extendCanvasGroupProps();

    return new fabric.Group([circle, textObject], {
        ...data,
        left: dropOnX + adjustedRadius,
        top: dropOnY + adjustedRadius,
        originX: 'center',
        originY: 'center',
        type: 'group',
        product: data.currentFiller || data.toxin,
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false,
        shape: 'circle',
        borderColor: borderColour,
        color: color
    });
};

export default addCanvasCircle;
